import { Component, OnInit } from '@angular/core';
import { FileType, GlobalFunctions } from 'globales-projekt-angular';
import { FileAppMetaDatas } from 'src/app/data/anwendung/FileAppMetaDatas.model';
import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { DateiTyp } from 'src/app/immutable/enums/datei-typ';
import { ApiService } from 'src/app/services/api.service';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  titleHaupttitel = ConstantsTexte.ANWENDUNGSNAME;
  titleNebentitel = ConstantsTexte.ENTWICKLUNGSTEXT;

  fileAppMetaDatas: FileAppMetaDatas = new FileAppMetaDatas(this.localService, this.apiService);

  constructor(private localService: LocalService, private apiService: ApiService) { }

  ngOnInit(): void {
    this.fileAppMetaDatas.loadFileAppMetaDatas();
  }

  downloadFileWinddatenCsv() {
    this.downloadFile(
      this.fileAppMetaDatas.winddatenCsv.type,
      DateiTyp.WINDDATEN_CSV,
      ConstantsSonstige.FILENAME_WINDDATEN_CSV,
      this.fileAppMetaDatas.winddatenCsv.endung
    );
  }

  downloadFile(
    type: FileType,
    dateiTyp: DateiTyp,
    fileName: string,
    fileEndung: FileType
  ) {


    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService
      .getAppFileDocuments(dateiTyp)
      .subscribe(async (response) => {
        GlobalFunctions.downloadFile(type, response, fileName, fileEndung);
        this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
      });
  }
}
